export default __webpack_public_path__ + "static/media/new_03.0bb7db6b.jpg";